module.exports = __webpack_public_path__ + "img/pgx-logo.e398d293.png";